<template>
    <rkm-table
        :fields="fields.tables.tipo"
        :items="data.model.ocupacoes"
        ref="Table"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                color="danger"
                title="Excluir"
                small
                @click.stop="handleDestroy(item)"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>

// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        fields() {
            return {
                tables: {
                    tipo: [
                        { key: 'nome', label: 'CBO', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        }
    },
    methods: {

        handleDestroy(item) {

            const objId = this.data.model.ocupacoes.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.ocupacoes.splice(objId, 1)

            this.showDeleteConfirmation(`Deseja realmente excluir a ocupação <strong>${ item.nome }</strong>?`, destroy)
        },
    },
    mixins: [ object ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>